import { createPaths } from "../utils";

import type { IExtractRouteParamMap } from "../types";

const baseRoute = `/support`;

export const supportRoutesObj = {
  home: baseRoute,
} as const;

export type ISupportRouteParams = IExtractRouteParamMap<
  typeof supportRoutesObj
>;

export const supportPath = createPaths<
  typeof supportRoutesObj,
  ISupportRouteParams
>(supportRoutesObj);
